export enum MeetingStatus {
  Created = 'created',
  JoiningCall = 'joining_call',
  InWaitingRoom = 'in_waiting_room',
  InCallNotRecording = 'in_call_not_recording',
  InCallRecording = 'in_call_recording',
  CallEnded = 'call_ended',
  RecordingDone = 'recording_done',
  Done = 'done',
  Fatal = 'fatal'
}

export function isMeetingInProgress(status: MeetingStatus) {
  return status === MeetingStatus.InCallRecording || status === MeetingStatus.JoiningCall;
}

export function isMeetingCanAddFollowUpItem(status: MeetingStatus) {
  return (
    status === MeetingStatus.Created ||
    status === MeetingStatus.JoiningCall ||
    status === MeetingStatus.InWaitingRoom ||
    status === MeetingStatus.InCallNotRecording ||
    status === MeetingStatus.InCallRecording
  );
}

export function isMeetingNotStarted(status: MeetingStatus) {
  return status === MeetingStatus.Created;
}
